import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Add from '@mui/icons-material/Add';
import ArrowBack from '@mui/icons-material/ArrowBack';
import PageHeader from '../../../Components/PageHeader';
import TablePeo from '../../../Components/TablePeo';
import { useApiGet } from '../../../utils/httpClientTs';
import { listOnlineItems } from '../../../endpoints/chapterSupplies';

const headCells = [
  { id: 'item_name', firstCell: true, label: 'Item name', width: '28%' },
  { id: 'price', label: 'Price', width: '12%' },
  { id: 'is_featured', label: 'Featured', width: '10%' },
  { id: 'is_discontinued', label: 'Discontinued', width: '12%' },
  { id: 'sort_order', label: 'Sort', width: '10%' },
  {
    id: 'created_at',
    label: 'Created',
    width: '28%',
    format: (value: unknown) =>
      value
        ? new Date(value as string).toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })
        : '',
  },
];

export default function OnlineItemList() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [order, setOrder] = useState<'asc' | 'desc'>('desc');
  const [orderBy, setOrderBy] = useState('created_at');

  const limit = rowsPerPage;
  const offset = page * rowsPerPage;

  const { data, isFetching } = useApiGet(
    ['chapter-supplies-online-items', limit, offset],
    () => listOnlineItems({ limit, offset }),
    { enabled: true, retry: 1 }
  );

  const onlineItems = data?.online_items ?? [];
  const handleRowClick = (_event: React.MouseEvent, rowId: string | number) => {
    navigate(`/chapter-supplies-management/online-items/${rowId}`);
  };

  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12}>
        <PageHeader
          title="Online Items"
          leftDom={
            <Button
              startIcon={<ArrowBack />}
              onClick={() => navigate('/chapter-supplies-management')}
            >
              Back
            </Button>
          }
          rightDom={
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() =>
                navigate('/chapter-supplies-management/online-items/create')
              }
            >
              Add online item
            </Button>
          }
          subtitle={undefined}
        />
      </Grid>
      <TablePeo
        data={onlineItems}
        isFetching={isFetching}
        headCells={headCells}
        handleRowClick={handleRowClick}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        emptyMessage="No online items yet. Create one to get started."
      />
    </Grid>
  );
}
